import Link from 'next/link';
import { CircleArrowRight } from 'lucide-react';

type TitleBoxProps = {
  title: string;
  subtitle: string;
  link: string;
  isExternal: boolean;
  colSpan?: number;
  rowSpan?: number;
  rowStart?: number;
  minHeight?: number;
  border?: string;
};

const TitleBox = ({
  title,
  subtitle,
  link,
  isExternal,
  colSpan,
  rowSpan,
  rowStart,
  minHeight,
  border,
}: TitleBoxProps) => {
  return (
    <Link
      href={link}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      aria-label={`Read more about ${title}`}
      style={{
        minHeight: `${minHeight}px`,
      }}
      className={`col-span-${colSpan} row-span-${rowSpan} ${rowStart ? `row-start-${rowStart}` : ''} p-4 bg-[#f8f8f8] transition-colors transition-background duration-500 group hover:text-[#BF984D] hover:bg-[#E0E0E0] ${border} border border-[#BF984D]`}
    >
      <div className="flex flex-col justify-end items-start h-full">
        <div className="flex flex-col justify-end items-start h-full">
          <span className="text-[1.05rem] text-[#BF984D] whitespace-pre-line">
            {title}
          </span>
          <span className="text-[1.05rem] pb-4 whitespace-pre-line">
            {subtitle}
          </span>
        </div>
        <CircleArrowRight
          className="text-lg text-[#BF984D] transition-transform group-hover:translate-x-1 duration-500"
          aria-hidden="true"
          size="32"
        />
      </div>
    </Link>
  );
};

export default TitleBox;
